import { render, staticRenderFns } from "./FirearmInstructorUnitStandards.vue?vue&type=template&id=79fb7638&"
import script from "./FirearmInstructorUnitStandards.vue?vue&type=script&lang=ts&"
export * from "./FirearmInstructorUnitStandards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports